module.exports = __webpack_public_path__ + "img/home-siji.d2dd2e65.png";